module.exports = __webpack_public_path__ + "img/no-login.d98a074f.png";